import { createContext, useReducer, } from 'react';

export const AppbarContext = createContext();

const libraryInitialState = {
    anchorElLibrary: null,
    scrollableTabsLibrarySelected: 0,
};

const userMenuInitialState = {
    anchorElUser: null,
};

const drawerMenuInitialState = {
    drawerMenuIsOpen: false,
};

const accordionMenuInitialState = {
    accordionMenuIsOpen: true,
};

const accordionLibraryInitialState = {
    accordionLibraryIsOpen: true,
};

const accordionCreateInitialState = {
    accordionCreateIsOpen: false,
};

const initialState = {
    ...libraryInitialState,
    ...userMenuInitialState,
    ...drawerMenuInitialState,
    ...accordionMenuInitialState,
    ...accordionLibraryInitialState,
    ...accordionCreateInitialState,
};

export const appbarReducer = (state, action) => {
    switch (action.type) {
        case 'CUSTOMIZED-TABS-LIBRARY/OPEN':
            return {
                ...state,
                anchorElLibrary: action.payload,
            };

        case 'CUSTOMIZED-TABS-LIBRARY/CLOSE':
            return {
                ...state,
                anchorElLibrary: null,
            };

        case 'SCROLLABLE-TABS-LIBRARY/CHANGE':
            return {
                ...state,
                scrollableTabsLibrarySelected: action.payload,
            };

        case 'USER-MENU/OPEN':
            return {
                ...state,
                anchorElUser: action.payload,
            };

        case 'USER-MENU/CLOSE':
            return {
                ...state,
                anchorElUser: null,
            };

        case 'DRAWER-MENU/OPEN':
            return {
                ...state,
                drawerMenuIsOpen: true,
            };

        case 'DRAWER-MENU/CLOSE':
            return {
                ...state,
                drawerMenuIsOpen: false,
            };

        case 'ACCORDION-MENU/TOGGLE':
            return {
                ...state,
                accordionMenuIsOpen: !state.accordionMenuIsOpen,
            };

        case 'ACCORDION-LIBRARY/TOGGLE':
            return {
                ...state,
                accordionLibraryIsOpen: !state.accordionLibraryIsOpen,
            };

        case 'ACCORDION-CREATE/TOGGLE':
            return {
                ...state,
                accordionCreateIsOpen: !state.accordionCreateIsOpen,
            };

        default:
            return state;
    }
};

export const AppbarContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(appbarReducer, initialState);

    const actions = {
        customizedTabsLibraryOpen(event) {
            dispatch({ type: 'CUSTOMIZED-TABS-LIBRARY/OPEN', payload: event.currentTarget, });
        },
        customizedTabsLibraryClose() {
            dispatch({ type: 'CUSTOMIZED-TABS-LIBRARY/CLOSE', });
        },
        scrollableTabsLibraryChange(_, newValue) {
            dispatch({ type: 'SCROLLABLE-TABS-LIBRARY/CHANGE', payload: newValue, });
        },
        userMenuOpen(event) {
            dispatch({ type: 'USER-MENU/OPEN', payload: event.currentTarget, });
        },
        userMenuClose() {
            dispatch({ type: 'USER-MENU/CLOSE', });
        },
        drawerMenuOpen() {
            dispatch({ type: 'DRAWER-MENU/OPEN', });
        },
        drawerMenuClose() {
            dispatch({ type: 'DRAWER-MENU/CLOSE', });
        },
        accordionMenuToggle() {
            dispatch({ type: 'ACCORDION-MENU/TOGGLE', });
        },
        accordionLibraryToggle() {
            dispatch({ type: 'ACCORDION-LIBRARY/TOGGLE', });
        },
        accordionCreateToggle() {
            dispatch({ type: 'ACCORDION-CREATE/TOGGLE', });
        },
    };

    return (
        <AppbarContext.Provider value={{...state, ...actions}}>
            { children }
        </AppbarContext.Provider>
    );
};